"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-envelope.tsx
var Envelope = function Envelope(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_537_42977)"
  }, (0, _preact.h)("path", {
    d: "M14.6663 3.99996C14.6663 3.26663 14.0663 2.66663 13.333 2.66663H2.66634C1.93301 2.66663 1.33301 3.26663 1.33301 3.99996V12C1.33301 12.7333 1.93301 13.3333 2.66634 13.3333H13.333C14.0663 13.3333 14.6663 12.7333 14.6663 12V3.99996ZM13.333 3.99996L7.99967 7.33329L2.66634 3.99996H13.333ZM13.333 12H2.66634V5.33329L7.99967 8.66663L13.333 5.33329V12Z"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_537_42977"
  }, (0, _preact.h)("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var _default = Envelope;
exports.default = _default;